/**
 * ApiGest API
 * ApiGest API documentation
 *
 * OpenAPI spec version: 1.0.0
 * Contact: info@eneasys.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PermissionDTO } from '../model/permissionDTO';

import { AIG_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PermissionResourceService {

    protected basePath = 'https://api-gest.eneasys.net';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(AIG_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * countPermissions
     * 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param moduleIdEquals 
     * @param moduleIdGreaterThan 
     * @param moduleIdGreaterThanOrEqual 
     * @param moduleIdIn 
     * @param moduleIdLessThan 
     * @param moduleIdLessThanOrEqual 
     * @param moduleIdNotEquals 
     * @param moduleIdSpecified 
     * @param nameContains 
     * @param nameDoesNotContain 
     * @param nameEquals 
     * @param nameIn 
     * @param nameNotEquals 
     * @param nameSpecified 
     * @param permissionCodeContains 
     * @param permissionCodeDoesNotContain 
     * @param permissionCodeEquals 
     * @param permissionCodeIn 
     * @param permissionCodeNotEquals 
     * @param permissionCodeSpecified 
     * @param roleIdEquals 
     * @param roleIdGreaterThan 
     * @param roleIdGreaterThanOrEqual 
     * @param roleIdIn 
     * @param roleIdLessThan 
     * @param roleIdLessThanOrEqual 
     * @param roleIdNotEquals 
     * @param roleIdSpecified 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public countPermissionsUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, moduleIdEquals?: number, moduleIdGreaterThan?: number, moduleIdGreaterThanOrEqual?: number, moduleIdIn?: Array<number>, moduleIdLessThan?: number, moduleIdLessThanOrEqual?: number, moduleIdNotEquals?: number, moduleIdSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, permissionCodeContains?: string, permissionCodeDoesNotContain?: string, permissionCodeEquals?: string, permissionCodeIn?: Array<string>, permissionCodeNotEquals?: string, permissionCodeSpecified?: boolean, roleIdEquals?: number, roleIdGreaterThan?: number, roleIdGreaterThanOrEqual?: number, roleIdIn?: Array<number>, roleIdLessThan?: number, roleIdLessThanOrEqual?: number, roleIdNotEquals?: number, roleIdSpecified?: boolean, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public countPermissionsUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, moduleIdEquals?: number, moduleIdGreaterThan?: number, moduleIdGreaterThanOrEqual?: number, moduleIdIn?: Array<number>, moduleIdLessThan?: number, moduleIdLessThanOrEqual?: number, moduleIdNotEquals?: number, moduleIdSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, permissionCodeContains?: string, permissionCodeDoesNotContain?: string, permissionCodeEquals?: string, permissionCodeIn?: Array<string>, permissionCodeNotEquals?: string, permissionCodeSpecified?: boolean, roleIdEquals?: number, roleIdGreaterThan?: number, roleIdGreaterThanOrEqual?: number, roleIdIn?: Array<number>, roleIdLessThan?: number, roleIdLessThanOrEqual?: number, roleIdNotEquals?: number, roleIdSpecified?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public countPermissionsUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, moduleIdEquals?: number, moduleIdGreaterThan?: number, moduleIdGreaterThanOrEqual?: number, moduleIdIn?: Array<number>, moduleIdLessThan?: number, moduleIdLessThanOrEqual?: number, moduleIdNotEquals?: number, moduleIdSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, permissionCodeContains?: string, permissionCodeDoesNotContain?: string, permissionCodeEquals?: string, permissionCodeIn?: Array<string>, permissionCodeNotEquals?: string, permissionCodeSpecified?: boolean, roleIdEquals?: number, roleIdGreaterThan?: number, roleIdGreaterThanOrEqual?: number, roleIdIn?: Array<number>, roleIdLessThan?: number, roleIdLessThanOrEqual?: number, roleIdNotEquals?: number, roleIdSpecified?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public countPermissionsUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, moduleIdEquals?: number, moduleIdGreaterThan?: number, moduleIdGreaterThanOrEqual?: number, moduleIdIn?: Array<number>, moduleIdLessThan?: number, moduleIdLessThanOrEqual?: number, moduleIdNotEquals?: number, moduleIdSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, permissionCodeContains?: string, permissionCodeDoesNotContain?: string, permissionCodeEquals?: string, permissionCodeIn?: Array<string>, permissionCodeNotEquals?: string, permissionCodeSpecified?: boolean, roleIdEquals?: number, roleIdGreaterThan?: number, roleIdGreaterThanOrEqual?: number, roleIdIn?: Array<number>, roleIdLessThan?: number, roleIdLessThanOrEqual?: number, roleIdNotEquals?: number, roleIdSpecified?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (moduleIdEquals !== undefined && moduleIdEquals !== null) {
            queryParameters = queryParameters.set('moduleId.equals', <any>moduleIdEquals);
        }
        if (moduleIdGreaterThan !== undefined && moduleIdGreaterThan !== null) {
            queryParameters = queryParameters.set('moduleId.greaterThan', <any>moduleIdGreaterThan);
        }
        if (moduleIdGreaterThanOrEqual !== undefined && moduleIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('moduleId.greaterThanOrEqual', <any>moduleIdGreaterThanOrEqual);
        }
        if (moduleIdIn) {
            moduleIdIn.forEach((element) => {
                queryParameters = queryParameters.append('moduleId.in', <any>element);
            })
        }
        if (moduleIdLessThan !== undefined && moduleIdLessThan !== null) {
            queryParameters = queryParameters.set('moduleId.lessThan', <any>moduleIdLessThan);
        }
        if (moduleIdLessThanOrEqual !== undefined && moduleIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('moduleId.lessThanOrEqual', <any>moduleIdLessThanOrEqual);
        }
        if (moduleIdNotEquals !== undefined && moduleIdNotEquals !== null) {
            queryParameters = queryParameters.set('moduleId.notEquals', <any>moduleIdNotEquals);
        }
        if (moduleIdSpecified !== undefined && moduleIdSpecified !== null) {
            queryParameters = queryParameters.set('moduleId.specified', <any>moduleIdSpecified);
        }
        if (nameContains !== undefined && nameContains !== null) {
            queryParameters = queryParameters.set('name.contains', <any>nameContains);
        }
        if (nameDoesNotContain !== undefined && nameDoesNotContain !== null) {
            queryParameters = queryParameters.set('name.doesNotContain', <any>nameDoesNotContain);
        }
        if (nameEquals !== undefined && nameEquals !== null) {
            queryParameters = queryParameters.set('name.equals', <any>nameEquals);
        }
        if (nameIn) {
            nameIn.forEach((element) => {
                queryParameters = queryParameters.append('name.in', <any>element);
            })
        }
        if (nameNotEquals !== undefined && nameNotEquals !== null) {
            queryParameters = queryParameters.set('name.notEquals', <any>nameNotEquals);
        }
        if (nameSpecified !== undefined && nameSpecified !== null) {
            queryParameters = queryParameters.set('name.specified', <any>nameSpecified);
        }
        if (permissionCodeContains !== undefined && permissionCodeContains !== null) {
            queryParameters = queryParameters.set('permissionCode.contains', <any>permissionCodeContains);
        }
        if (permissionCodeDoesNotContain !== undefined && permissionCodeDoesNotContain !== null) {
            queryParameters = queryParameters.set('permissionCode.doesNotContain', <any>permissionCodeDoesNotContain);
        }
        if (permissionCodeEquals !== undefined && permissionCodeEquals !== null) {
            queryParameters = queryParameters.set('permissionCode.equals', <any>permissionCodeEquals);
        }
        if (permissionCodeIn) {
            permissionCodeIn.forEach((element) => {
                queryParameters = queryParameters.append('permissionCode.in', <any>element);
            })
        }
        if (permissionCodeNotEquals !== undefined && permissionCodeNotEquals !== null) {
            queryParameters = queryParameters.set('permissionCode.notEquals', <any>permissionCodeNotEquals);
        }
        if (permissionCodeSpecified !== undefined && permissionCodeSpecified !== null) {
            queryParameters = queryParameters.set('permissionCode.specified', <any>permissionCodeSpecified);
        }
        if (roleIdEquals !== undefined && roleIdEquals !== null) {
            queryParameters = queryParameters.set('roleId.equals', <any>roleIdEquals);
        }
        if (roleIdGreaterThan !== undefined && roleIdGreaterThan !== null) {
            queryParameters = queryParameters.set('roleId.greaterThan', <any>roleIdGreaterThan);
        }
        if (roleIdGreaterThanOrEqual !== undefined && roleIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('roleId.greaterThanOrEqual', <any>roleIdGreaterThanOrEqual);
        }
        if (roleIdIn) {
            roleIdIn.forEach((element) => {
                queryParameters = queryParameters.append('roleId.in', <any>element);
            })
        }
        if (roleIdLessThan !== undefined && roleIdLessThan !== null) {
            queryParameters = queryParameters.set('roleId.lessThan', <any>roleIdLessThan);
        }
        if (roleIdLessThanOrEqual !== undefined && roleIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('roleId.lessThanOrEqual', <any>roleIdLessThanOrEqual);
        }
        if (roleIdNotEquals !== undefined && roleIdNotEquals !== null) {
            queryParameters = queryParameters.set('roleId.notEquals', <any>roleIdNotEquals);
        }
        if (roleIdSpecified !== undefined && roleIdSpecified !== null) {
            queryParameters = queryParameters.set('roleId.specified', <any>roleIdSpecified);
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('get',`${this.basePath}/m8t/api/permissions/count`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createPermission
     * 
     * @param body permissionDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createPermissionUsingPOST(body: PermissionDTO, observe?: 'body', reportProgress?: boolean): Observable<PermissionDTO>;
    public createPermissionUsingPOST(body: PermissionDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PermissionDTO>>;
    public createPermissionUsingPOST(body: PermissionDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PermissionDTO>>;
    public createPermissionUsingPOST(body: PermissionDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createPermissionUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<PermissionDTO>('post',`${this.basePath}/m8t/api/permissions`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deletePermission
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deletePermissionUsingDELETE(id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deletePermissionUsingDELETE(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deletePermissionUsingDELETE(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deletePermissionUsingDELETE(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deletePermissionUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/m8t/api/permissions/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAllPermissions
     * 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param moduleIdEquals 
     * @param moduleIdGreaterThan 
     * @param moduleIdGreaterThanOrEqual 
     * @param moduleIdIn 
     * @param moduleIdLessThan 
     * @param moduleIdLessThanOrEqual 
     * @param moduleIdNotEquals 
     * @param moduleIdSpecified 
     * @param nameContains 
     * @param nameDoesNotContain 
     * @param nameEquals 
     * @param nameIn 
     * @param nameNotEquals 
     * @param nameSpecified 
     * @param page Page number of the requested page
     * @param permissionCodeContains 
     * @param permissionCodeDoesNotContain 
     * @param permissionCodeEquals 
     * @param permissionCodeIn 
     * @param permissionCodeNotEquals 
     * @param permissionCodeSpecified 
     * @param roleIdEquals 
     * @param roleIdGreaterThan 
     * @param roleIdGreaterThanOrEqual 
     * @param roleIdIn 
     * @param roleIdLessThan 
     * @param roleIdLessThanOrEqual 
     * @param roleIdNotEquals 
     * @param roleIdSpecified 
     * @param size Size of a page
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllPermissionsUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, moduleIdEquals?: number, moduleIdGreaterThan?: number, moduleIdGreaterThanOrEqual?: number, moduleIdIn?: Array<number>, moduleIdLessThan?: number, moduleIdLessThanOrEqual?: number, moduleIdNotEquals?: number, moduleIdSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, page?: number, permissionCodeContains?: string, permissionCodeDoesNotContain?: string, permissionCodeEquals?: string, permissionCodeIn?: Array<string>, permissionCodeNotEquals?: string, permissionCodeSpecified?: boolean, roleIdEquals?: number, roleIdGreaterThan?: number, roleIdGreaterThanOrEqual?: number, roleIdIn?: Array<number>, roleIdLessThan?: number, roleIdLessThanOrEqual?: number, roleIdNotEquals?: number, roleIdSpecified?: boolean, size?: number, sort?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<PermissionDTO>>;
    public getAllPermissionsUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, moduleIdEquals?: number, moduleIdGreaterThan?: number, moduleIdGreaterThanOrEqual?: number, moduleIdIn?: Array<number>, moduleIdLessThan?: number, moduleIdLessThanOrEqual?: number, moduleIdNotEquals?: number, moduleIdSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, page?: number, permissionCodeContains?: string, permissionCodeDoesNotContain?: string, permissionCodeEquals?: string, permissionCodeIn?: Array<string>, permissionCodeNotEquals?: string, permissionCodeSpecified?: boolean, roleIdEquals?: number, roleIdGreaterThan?: number, roleIdGreaterThanOrEqual?: number, roleIdIn?: Array<number>, roleIdLessThan?: number, roleIdLessThanOrEqual?: number, roleIdNotEquals?: number, roleIdSpecified?: boolean, size?: number, sort?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PermissionDTO>>>;
    public getAllPermissionsUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, moduleIdEquals?: number, moduleIdGreaterThan?: number, moduleIdGreaterThanOrEqual?: number, moduleIdIn?: Array<number>, moduleIdLessThan?: number, moduleIdLessThanOrEqual?: number, moduleIdNotEquals?: number, moduleIdSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, page?: number, permissionCodeContains?: string, permissionCodeDoesNotContain?: string, permissionCodeEquals?: string, permissionCodeIn?: Array<string>, permissionCodeNotEquals?: string, permissionCodeSpecified?: boolean, roleIdEquals?: number, roleIdGreaterThan?: number, roleIdGreaterThanOrEqual?: number, roleIdIn?: Array<number>, roleIdLessThan?: number, roleIdLessThanOrEqual?: number, roleIdNotEquals?: number, roleIdSpecified?: boolean, size?: number, sort?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PermissionDTO>>>;
    public getAllPermissionsUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, moduleIdEquals?: number, moduleIdGreaterThan?: number, moduleIdGreaterThanOrEqual?: number, moduleIdIn?: Array<number>, moduleIdLessThan?: number, moduleIdLessThanOrEqual?: number, moduleIdNotEquals?: number, moduleIdSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, page?: number, permissionCodeContains?: string, permissionCodeDoesNotContain?: string, permissionCodeEquals?: string, permissionCodeIn?: Array<string>, permissionCodeNotEquals?: string, permissionCodeSpecified?: boolean, roleIdEquals?: number, roleIdGreaterThan?: number, roleIdGreaterThanOrEqual?: number, roleIdIn?: Array<number>, roleIdLessThan?: number, roleIdLessThanOrEqual?: number, roleIdNotEquals?: number, roleIdSpecified?: boolean, size?: number, sort?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (moduleIdEquals !== undefined && moduleIdEquals !== null) {
            queryParameters = queryParameters.set('moduleId.equals', <any>moduleIdEquals);
        }
        if (moduleIdGreaterThan !== undefined && moduleIdGreaterThan !== null) {
            queryParameters = queryParameters.set('moduleId.greaterThan', <any>moduleIdGreaterThan);
        }
        if (moduleIdGreaterThanOrEqual !== undefined && moduleIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('moduleId.greaterThanOrEqual', <any>moduleIdGreaterThanOrEqual);
        }
        if (moduleIdIn) {
            moduleIdIn.forEach((element) => {
                queryParameters = queryParameters.append('moduleId.in', <any>element);
            })
        }
        if (moduleIdLessThan !== undefined && moduleIdLessThan !== null) {
            queryParameters = queryParameters.set('moduleId.lessThan', <any>moduleIdLessThan);
        }
        if (moduleIdLessThanOrEqual !== undefined && moduleIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('moduleId.lessThanOrEqual', <any>moduleIdLessThanOrEqual);
        }
        if (moduleIdNotEquals !== undefined && moduleIdNotEquals !== null) {
            queryParameters = queryParameters.set('moduleId.notEquals', <any>moduleIdNotEquals);
        }
        if (moduleIdSpecified !== undefined && moduleIdSpecified !== null) {
            queryParameters = queryParameters.set('moduleId.specified', <any>moduleIdSpecified);
        }
        if (nameContains !== undefined && nameContains !== null) {
            queryParameters = queryParameters.set('name.contains', <any>nameContains);
        }
        if (nameDoesNotContain !== undefined && nameDoesNotContain !== null) {
            queryParameters = queryParameters.set('name.doesNotContain', <any>nameDoesNotContain);
        }
        if (nameEquals !== undefined && nameEquals !== null) {
            queryParameters = queryParameters.set('name.equals', <any>nameEquals);
        }
        if (nameIn) {
            nameIn.forEach((element) => {
                queryParameters = queryParameters.append('name.in', <any>element);
            })
        }
        if (nameNotEquals !== undefined && nameNotEquals !== null) {
            queryParameters = queryParameters.set('name.notEquals', <any>nameNotEquals);
        }
        if (nameSpecified !== undefined && nameSpecified !== null) {
            queryParameters = queryParameters.set('name.specified', <any>nameSpecified);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (permissionCodeContains !== undefined && permissionCodeContains !== null) {
            queryParameters = queryParameters.set('permissionCode.contains', <any>permissionCodeContains);
        }
        if (permissionCodeDoesNotContain !== undefined && permissionCodeDoesNotContain !== null) {
            queryParameters = queryParameters.set('permissionCode.doesNotContain', <any>permissionCodeDoesNotContain);
        }
        if (permissionCodeEquals !== undefined && permissionCodeEquals !== null) {
            queryParameters = queryParameters.set('permissionCode.equals', <any>permissionCodeEquals);
        }
        if (permissionCodeIn) {
            permissionCodeIn.forEach((element) => {
                queryParameters = queryParameters.append('permissionCode.in', <any>element);
            })
        }
        if (permissionCodeNotEquals !== undefined && permissionCodeNotEquals !== null) {
            queryParameters = queryParameters.set('permissionCode.notEquals', <any>permissionCodeNotEquals);
        }
        if (permissionCodeSpecified !== undefined && permissionCodeSpecified !== null) {
            queryParameters = queryParameters.set('permissionCode.specified', <any>permissionCodeSpecified);
        }
        if (roleIdEquals !== undefined && roleIdEquals !== null) {
            queryParameters = queryParameters.set('roleId.equals', <any>roleIdEquals);
        }
        if (roleIdGreaterThan !== undefined && roleIdGreaterThan !== null) {
            queryParameters = queryParameters.set('roleId.greaterThan', <any>roleIdGreaterThan);
        }
        if (roleIdGreaterThanOrEqual !== undefined && roleIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('roleId.greaterThanOrEqual', <any>roleIdGreaterThanOrEqual);
        }
        if (roleIdIn) {
            roleIdIn.forEach((element) => {
                queryParameters = queryParameters.append('roleId.in', <any>element);
            })
        }
        if (roleIdLessThan !== undefined && roleIdLessThan !== null) {
            queryParameters = queryParameters.set('roleId.lessThan', <any>roleIdLessThan);
        }
        if (roleIdLessThanOrEqual !== undefined && roleIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('roleId.lessThanOrEqual', <any>roleIdLessThanOrEqual);
        }
        if (roleIdNotEquals !== undefined && roleIdNotEquals !== null) {
            queryParameters = queryParameters.set('roleId.notEquals', <any>roleIdNotEquals);
        }
        if (roleIdSpecified !== undefined && roleIdSpecified !== null) {
            queryParameters = queryParameters.set('roleId.specified', <any>roleIdSpecified);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<PermissionDTO>>('get',`${this.basePath}/m8t/api/permissions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getPermission
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPermissionUsingGET(id: number, observe?: 'body', reportProgress?: boolean): Observable<PermissionDTO>;
    public getPermissionUsingGET(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PermissionDTO>>;
    public getPermissionUsingGET(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PermissionDTO>>;
    public getPermissionUsingGET(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getPermissionUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PermissionDTO>('get',`${this.basePath}/m8t/api/permissions/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updatePermission
     * 
     * @param body permissionDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatePermissionUsingPUT(body: PermissionDTO, observe?: 'body', reportProgress?: boolean): Observable<PermissionDTO>;
    public updatePermissionUsingPUT(body: PermissionDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PermissionDTO>>;
    public updatePermissionUsingPUT(body: PermissionDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PermissionDTO>>;
    public updatePermissionUsingPUT(body: PermissionDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updatePermissionUsingPUT.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<PermissionDTO>('put',`${this.basePath}/m8t/api/permissions`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
